import { Directive, ElementRef, HostListener, forwardRef, Input } from '@angular/core'
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms'

@Directive({
    selector: '[appPhoneFormat]',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => PhoneFormatDirective),
            multi: true,
        },
    ],
})
export class PhoneFormatDirective implements ControlValueAccessor {
    @Input() showSeparator: boolean = true
    private onChange = (val: string) => {}
    private onTouched = () => {}

    constructor(private el: ElementRef) {}

    @HostListener('input', ['$event'])
    onInput(event: Event) {
        const input = this.el.nativeElement
        let value = input.value.replace(/\D/g, '')
        if (value.length > 10) {
            value = value.substring(0, 10)
        }
        if (!this.showSeparator) {
            input.value = value
        } else {
            input.value = this.formatPhone(value)
        }
        this.onChange(value?.toString()) // Truyền giá trị số thô
    }

    writeValue(value: string): void {
        if (value) {
            const numbers = value.replace(/\D/g, '')
            this.el.nativeElement.value = this.formatPhone(numbers)
        } else {
            this.el.nativeElement.value = ''
        }
    }

    private formatPhone(value: string): string {
        let formattedValue = ''
        if (value.length > 0) {
            formattedValue = '(' + value.substring(0, 3)

            if (value.length > 3) {
                formattedValue += ') ' + value.substring(3, 6)
            }

            if (value.length > 6) {
                formattedValue += '-' + value.substring(6, 10)
            }
        }
        return formattedValue
    }

    registerOnChange(fn: any): void {
        this.onChange = fn
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn
    }
}
